export default __webpack_public_path__ + "static/media/bluffing.b2ff0f1c.gif";